import i18n from '@/locales'

/** 系统服务侧栏监控：measurement / field 与采集端约定一致（worker / process） */
export const SERVICE_MONITOR_OPTS = [
  {
    name: 'queue_cnt',
    label: i18n.t('system.service_monitor_queue_cnt'),
    seleteItem: 'queue_cnt',
    fromItem: 'worker',
    unit: '',
    transfer: 1,
  },
  {
    name: 'active_worker_cnt',
    label: i18n.t('system.service_monitor_active_worker_cnt'),
    seleteItem: 'active_worker_cnt',
    fromItem: 'worker',
    unit: '',
    transfer: 1,
  },
  {
    name: 'cpu_percent',
    label: i18n.t('compute.text_523'),
    seleteItem: 'cpu_percent',
    fromItem: 'process',
    unit: '%',
    transfer: 1,
  },
  {
    name: 'mem_percent',
    label: i18n.t('compute.text_518'),
    seleteItem: 'mem_percent',
    fromItem: 'process',
    unit: '%',
    transfer: 1,
  },
]

export const supportTabs = [
  { name: 'echarts-ssr', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'mcp-server', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'llm', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'opentsdb', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'fsgateway', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'bastionhost', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'autoupdate', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'cloudid', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'report', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'yunionconf', monitor: true, worker: true, db: true, api: true, task: false, config: true },
  { name: 'extdb', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'cloudevent', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'devtool', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'itsm', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'cloudproxy', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'notify', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'log', monitor: false, worker: true, db: true, api: true, task: false, config: false },
  { name: 'baremetal', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'suggestion', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'scheduledtask', monitor: true, worker: true, db: true, api: true, task: false, config: true },
  { name: 'lbagent', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'cloudmon', monitor: true, worker: true, db: false, api: true, task: false, config: true },
  { name: 'monitor', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'host', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'vpcagent', monitor: true, worker: true, db: false, api: true, task: false, config: true },
  { name: 'apimap', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'billing', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'meter', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'yunionapi', monitor: true, worker: true, db: false, api: true, task: false, config: false },
  { name: 'websocket', monitor: false, worker: true, db: false, api: true, task: false, config: false },
  { name: 'ansible', monitor: true, worker: true, db: true, api: true, task: false, config: false },
  { name: 'yunionagent', monitor: true, worker: true, db: false, api: true, task: false, config: false },
  { name: 'glance', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'webconsole', monitor: true, worker: true, db: false, api: true, task: false, config: false },
  { name: 'k8s', monitor: true, worker: true, db: false, api: true, task: false, config: false },
  { name: 'scheduler', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'region2', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'victoria-metrics', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'offlinecloudmeta', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'keystone', alias: 'keystone', monitor: true, worker: true, db: true, api: true, task: true, config: true },
  { name: 'external-service', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'etcd', monitor: false, worker: false, db: false, api: false, task: false, config: false },
  { name: 'common', monitor: false, worker: false, db: false, api: false, task: true, config: false },
  { name: 'custom-host-list', monitor: false, worker: true, db: false, api: true, task: false, config: true },
]
